import { useNavigate } from 'react-router-dom';
import Button from '../ui/Button';
import PeopleConnectionRow from './PeopleConnectionRow';
import { peopleListSurfaceClass } from '../../config/glassSurfaces';
import { useSuggestedPeople } from '../../hooks/queries/usePeopleQueries';

const PREVIEW_LIMIT = 5;

export default function DiscoverPeopleSection({
  currentUserId,
  enabled,
  followingIds,
  optimisticFollowing,
  followLoadingId,
  onFollow,
  onNavigate,
}) {
  const navigate = useNavigate();

  const { data: suggestedPeople = [], isPending } = useSuggestedPeople(currentUserId, {
    enabled: enabled && Boolean(currentUserId),
    limit: PREVIEW_LIMIT,
  });

  const previewPeople = suggestedPeople.slice(0, PREVIEW_LIMIT);

  if (!enabled) return null;

  if (isPending && previewPeople.length === 0) {
    return (
      <section className="mb-8" aria-hidden>
        <div className="mb-3 h-4 w-40 rounded skeleton-shimmer animate-pulse" />
        <div className={peopleListSurfaceClass()}>
          {Array.from({ length: 3 }).map((_, i) => (
            <div
              key={i}
              className="flex items-center justify-between gap-3 px-2 py-2.5 animate-pulse min-h-[52px]"
            >
              <div className="flex min-w-0 flex-1 items-center gap-3">
                <div className="h-9 w-9 rounded-full flex-shrink-0 skeleton-shimmer" />
                <div className="flex-1 min-w-0 space-y-2">
                  <div className="h-3.5 w-2/5 max-w-[140px] rounded skeleton-shimmer" />
                  <div className="h-3 w-24 rounded skeleton-shimmer" />
                </div>
              </div>
              <div className="h-7 w-16 rounded-md skeleton-shimmer shrink-0" />
            </div>
          ))}
        </div>
      </section>
    );
  }

  if (previewPeople.length === 0) return null;

  return (
    <section className="mb-8">
      <div className="mb-3 flex items-center justify-between gap-3">
        <h2 className="text-xs font-medium uppercase tracking-wide text-gray-500 dark:text-dark-muted">
          Discover
        </h2>
        <Button
          type="button"
          variant="secondary"
          size="sm"
          onClick={() => navigate('/profile/discover')}
        >
          See all
        </Button>
      </div>
      <div className={peopleListSurfaceClass()}>
        {previewPeople.map((person) => (
          <PeopleConnectionRow
            key={person.id}
            profile={person}
            subtitle={person.affinity_reason}
            isFollowing={followingIds.has(person.id) || optimisticFollowing.has(person.id)}
            isLoading={followLoadingId === person.id}
            onFollow={() => onFollow(person.id)}
            onNavigate={() => onNavigate(person.id)}
          />
        ))}
      </div>
    </section>
  );
}
